import { useGetPlanSetsQuery } from 'generated/graphql';
import React from 'react';
import { useParams } from 'react-router-dom';

export interface IData {
  id: string;
  name: string;
  displayName: string;
}

export function useQuery() {
  const params = useParams();
  const tuple = useGetPlanSetsQuery({
    variables: {
      options: {
        filter: {
          projectId: params.projectId ?? ''
        }
      }
    }
  });

  return React.useMemo(
    () => {
      const data: IData[] = tuple.data?.planSets.map((node) => ({
        id: node?.id ?? '',
        name: node?.name ?? 'approvedBuildingPlans',
        displayName: node?.displayName ?? ''
      })) ?? [];

      return {
        ...tuple,
        data
      };
    },
    [tuple]
  );
}
